export default __webpack_public_path__ + "static/media/sql.c650f2a7.png";